<template>
  <el-form ref="baseForm" :rules="rules" :model="fromData">
    <search-box @subSearch="subSearch" :fromData="fromData">
      <el-form-item class="item" label="采购订单号：" prop="purchaseOrderNo">
        <el-input v-model="fromData.searchCriteria.purchaseOrderNo" placeholder="请输入采购订单号"></el-input>
      </el-form-item>
    </search-box>
  </el-form>
</template>
<script>
import searchBox from "components/common/search.vue";
export default {
  components: {
    searchBox
  },
  props:{
		fromData:Object
	},

  created() {
  },
  methods: {
    subSearch() {
      this.$emit("subSearch");
    }
  }
};
</script>

<style>
</style>
